import { IncomingMessage } from 'http';
import { LOCALE_TYPE } from 'src/types/locale';

export enum Subdomain {
  WWW = 'www',
  TW = 'tw',
  HK = 'hk',
  JA = 'jp',
  CN = 'cn',
}

const getLocaleFromUrl = (): LOCALE_TYPE => {
  const subdomain = getSubdomainFromUrl(window.location.hostname);
  switch (subdomain) {
    case Subdomain.TW:
      return LOCALE_TYPE.TW;
    case Subdomain.HK:
      return LOCALE_TYPE.HK;
    case Subdomain.WWW:
      return LOCALE_TYPE.EN;
    case Subdomain.JA:
      return LOCALE_TYPE.JA;
    case Subdomain.CN:
      return LOCALE_TYPE.CN;
  }
};

const getHostname = (req: IncomingMessage | undefined): string => {
  if (req?.headers['x-forwarded-host']) {
    return req.headers['x-forwarded-host'] as string;
  }
  if (req?.headers['host']) {
    return req.headers['host'] as string;
  }
  return window.location.hostname;
};

const getSubdomainFromUrl = (hostname: string): Subdomain => {
  if (hostname === 'p.wamazing-cn.com' || hostname === 'staging.wamazing-cn.com') {
    return Subdomain.CN;
  }
  const subdomain = hostname.split('.')[0];

  switch (subdomain) {
    case 'jp':
      return Subdomain.JA;
    case 'tw':
      return Subdomain.TW;
    case 'hk':
      return Subdomain.HK;
    case 'www':
      return Subdomain.WWW;
    case 'cn': // local環境用
      return Subdomain.CN;
    default:
      return Subdomain.TW;
  }
};

const getSubdomainFromNextLocale = (locale: LOCALE_TYPE | undefined): Subdomain => {
  switch (locale) {
    case 'zh_tw':
      return Subdomain.TW;
    case 'zh_hk':
      return Subdomain.HK;
    case 'en':
      return Subdomain.WWW;
    case 'ja':
      return Subdomain.JA;
    case 'zh_cn':
      return Subdomain.CN;
    default:
      return Subdomain.WWW;
  }
};

const getSubdomainCountry = (req: IncomingMessage | undefined): Subdomain => {
  const hostname = getHostname(req);
  return getSubdomainFromUrl(hostname);
};

export { getHostname, getLocaleFromUrl, getSubdomainCountry, getSubdomainFromNextLocale, getSubdomainFromUrl };
